import { type i18n } from 'i18next';
import { OverviewData } from './Overview.types';
import { AdDetails } from '@/api/types/ads.types';

export const getOverviewData = (
  i18n: i18n,
  adDetails: AdDetails
): OverviewData[] => {
  const { legacyResourceId, hits } = adDetails;
  return [
    { id: 1, name: i18n.t('pages.ad.ad_number'), value: legacyResourceId },
    { id: 2, name: i18n.t('pages.ad.views'), value: hits },
  ];
};
